import { render, staticRenderFns } from "./page_invoices.vue?vue&type=template&id=2b5ca642&"
import script from "./page_invoices.vue?vue&type=script&lang=js&"
export * from "./page_invoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports